import { getFormattedIssueName, type IssueOrChild } from 'pages/Desk/issues/shared';
import { useMemo } from 'react';

export function useIssueName(issue: IssueOrChild | undefined) {
    return useMemo(() => (issue ? getFormattedIssueName(issue) : undefined), [issue]);
}
